import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebContentService {

     constructor (private http: HttpClient) { }

     getWebPageContent(page: string){
          const url = `${environment.APP_API_URL}/api/v1/Lists/GetContentForWebPage/{page}`
               .replace(`{${"page"}}`, encodeURIComponent(String(page)));
          return this.http.get(url)
               .pipe(
                    map((response: any) => {
                         return response;
                    }),
                    catchError(error => {
                         console.error(error);
                         return of([]);
                    })
               );
     }

     getWebPageContentPreview(page: string, previewItemId: string, previewParentItemId: string) {
          const url = `${environment.APP_API_URL}/api/v1/Lists/GetContentForWebPage/{page}/Preview?previewItemId={previewItemId}&previewParentItemId={previewParentItemId}`
               .replace(`{${"page"}}`, encodeURIComponent(String(page)))
               .replace(`{${"previewItemId"}}`, encodeURIComponent(String(previewItemId)))
               .replace(`{${"previewParentItemId"}}`, encodeURIComponent(String(previewParentItemId)));
          return this.http.get(url)
               .pipe(
                    map((response: any) => {
                         return response;
                    }),
                    catchError(error => {
                         console.error(error);
                         return of([]);
                    })
               );
     }
}
